<template>
  <div>     
    <CCard class="h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h4 class="mt-5" style="font-size:24px">
                Payment
                Subscription                
              </h4>
              <br />

              <p class="ml-3" style="font-size: 17px">View Right Answer</p>
              <p class="ml-3" style="font-size: 17px">RM 0.30</p>

              <div class="text-right">
              <CButton
                style="background-color: #F49159;
                color: #FFFFFF;
                border-radius: 15px;
                width: 25%;
                "                
                size="lg"
                class="mb-5"
                @click="GoToPageAnswerPreview()"
                >+Pay</CButton
              >
              </div>
              
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>

  
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgProfile.png";
import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,      
    };
  },
  async mounted() {},
  computed: {},
  methods: {
    GoToPageAnswerPreview() {
      this.$router.push(
        "/QuizStudentAnswerPreview"
      );
    }
  }
};
</script>
